import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { AngularDraggableModule } from "angular2-draggable";
import { BlocksRoutes } from "./blocks.routes";
import { IBlockRepository } from "../../domain/blocks/i-block.repository";
import { CachedBlocksRepository } from "../../infrastructure/blocks/cached-blocks-repository.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(BlocksRoutes, { onSameUrlNavigation: "reload" }),
  ],
  declarations: [],
  providers: [
    {
      provide: IBlockRepository,
      useClass: CachedBlocksRepository,
    },
  ],
  exports: [],
})
export class BlocksModule {}
